module.exports = __webpack_public_path__ + "img/thumb_06.fa083ad8.jpg";